import Hero from '../ui/hero/hero';
import LocalNews from '../ui/local-news/local-news';
import FeaturedPerson from '../ui/featured/featured-person';
import Projects from '../ui/projects/featured-projects';
import mockedFeaturedPerson from '../mocks/featured-person.json';
import mockedProjects from '../mocks/projects.json';
import mockHero from '../mocks/hero.json';
import mockNews from '../mocks/local-news.json';
import FacebookPost from '../ui/facebook/post';
import ApiService from '../services/api-service';
import './css/home.css';
import { useState, useEffect } from 'react';

const postWidgetHTML = '<div class="fb-post" data-href="https://www.facebook.com/NRNAAustralia/posts/4051963628168181" data-width="750" data-show-text="true"><blockquote cite="https://www.facebook.com/NRNAAustralia/posts/4051963628168181" class="fb-xfbml-parse-ignore"><p>#ChooseToChallenge I am incredibly grateful for your love, presence and support for our signature event “International...</p>Posted by <a href="https://www.facebook.com/NRNAAustralia/">NRNA Australia</a> on&nbsp;<a href="https://www.facebook.com/NRNAAustralia/posts/4051963628168181">Saturday, March 6, 2021</a></blockquote></div>';
function HomePage() {
  const [projects, setProjects] = useState(mockedProjects);
  const [featuredPeople, setFeaturedPeople] = useState();
  const [hero, setHero] = useState();
  const [news, setNews] = useState([]);

  const fetchFeatuedPerson = async () => {
    try {
      const response = await ApiService.get('featured-person');
      setFeaturedPeople(response[0]);
    } catch (exception) {
    }
  };
  const fetchHero = async () => {
    try {
      const response = await ApiService.get('hero');
      setHero(response[0]);
    } catch (exception) {
    }
  };

  const fetchNews = async () => {
    try {
      const response = await ApiService.get('news');
      setNews(response);
    } catch (exception) {
    }
  };
  useEffect(fetchFeatuedPerson, []);
  useEffect(fetchHero, []);
  useEffect(fetchNews, []);


  const FbPostCarousel = (postWidgetTML) => {
    return <div className="facebook-post-container">
      <FacebookPost widget={postWidgetHTML} />
    </div>
  };

  return (<>
    <Hero data={hero} />
    <LocalNews news={news}/>
    <div className="row">
      <div className="flex-col flex-container">
        <div className="flex-item"><Projects projects={projects} /></div>
        <div className="flex-item"><FeaturedPerson details={featuredPeople} /></div>
      </div>
      <div class="flex-col flex-container">
        <div className="flex-item-half">
          <div className="socials-heading">
            <h2>From our Facebook</h2>
          </div>
          <div className="socials-container">
            <FbPostCarousel postWidgetHTML={postWidgetHTML}/>
          </div>

        </div>
      </div>
    </div>
  </>
  );
}

export default HomePage;
